export const actionTypes = {
  SET_LOADING: 'loading/SET_LOADING',
} as const;
